import {createLog} from "./create-log.ts";
import {LazyAmbiguousErrorLog} from "./lazy-ambiguous-error-log.ts";
import type {IAmbiguousErrorLog} from "./types.ts";

/**
 * Central log through which all frontend log operations should pass.
 * @see {@link file://./types.ts} for API definition of
 * `IAmbiguousErrorLog`.
 */
export const lazyLog: IAmbiguousErrorLog = new LazyAmbiguousErrorLog(() =>
    /**
     * We create the log to be lazily instantiated, so that we do as little as
     * possible on import.
     */
    createLog(),
);
